<template>
  <div id="app">
    <v-container>
      <Header />
      <v-overlay :value="loader">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card class="mx-auto" max-width="1000" v-if="viewEvent">
        <v-toolbar flat>
          <v-toolbar-title class="grey--text"
            >Extract Email Addresses</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-text>
          <v-data-table
            v-model="selectedEvents"
            :headers="companyHeader"
            :items="companies"
            :sort-by="['name', 'eventName']"
            show-select
            :search="search"
            class="elevation-1"
          >
            <template v-slot:item.status="{ item }">
              <v-chip
                v-if="item.status == 'Live'"
                color="green lighten-4"
                class="ml-0 mr-2 black--text"
                label
                small
                >{{ item.status }}</v-chip
              >
              <v-chip
                v-else
                color="red lighten-4"
                class="ml-0 mr-2 black--text"
                label
                small
                >{{ item.status }}</v-chip
              >
            </template>
          </v-data-table>
          <div class="text-right pt-2">
            <v-btn color="primary" @click="selectEvents" class="hp--btn"
              >List Email Addresses</v-btn
            >
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mx-auto" max-width="1000" v-if="viewBooking">
        <v-toolbar flat>
          <v-toolbar-title class="grey--text"
            >Extract Email Addresses</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
        </v-toolbar>

        <v-divider></v-divider>

        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              color="info"
              dark
              small
              absolute
              top
              right
              fab
              v-on="on"
              @click="
                viewEvent = true;
                viewBooking = false;
              "
              class="mr-2 mt-8 hp--btn"
            >
              <v-icon>keyboard_return</v-icon>
            </v-btn>
          </template>
          <span>Go back</span>
        </v-tooltip>

        <v-card-text>
          <v-alert dense text type="success" v-if="clipboardMsg">
            Email addresses copied into
            <strong>clipboard</strong>
          </v-alert>
          <v-data-table
            v-model="selectedBookings"
            :headers="bookingHeader"
            :items="bookings"
            :sort-by="['email']"
            show-select
            class="elevation-1"
            item-key="id"
          ></v-data-table>
          <div class="text-right pt-2">
            <v-btn
              color="primary"
              @click="copyEmailsIntoClipboard"
              class="hp--btn"
              >Copy into clipboard</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import { API, graphqlOperation } from "aws-amplify";
import { Booking } from "../classes/Booking";

export default {
  components: {
    Header
  },
  data() {
    return {
      nextToken: null,
      clipboardMsg: false,
      viewEvent: true,
      selectedEvents: [],
      selectedBookings: [],
      companies: [],
      viewBooking: false,
      bookings: [],
      companyHeader: [
        {
          text: "Company",
          align: "start",
          sortable: true,
          value: "name"
        },
        { text: "Event", value: "eventName" },
        { text: "Status", value: "status" },
        { text: "Code", value: "code" }
      ],
      bookingHeader: [
        {
          text: "Email",
          align: "start",
          sortable: true,
          value: "email"
        },
        { text: "First name", value: "firstName" },
        { text: "Last name", value: "lastName" }
      ],
      loader: false,
      search: ""
    };
  },
  methods: {
    async nextCompanyRecord() {
      const listEventCompanys = `query ListEventCompanys(
          $filter: ModelEventCompanyFilterInput
          $limit: Int
          $nextToken: String
          ) {
          listEventCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
              items {
                  id
                  name
                  email
                  logo
                  createdAt
                  isDeleted
                  event(
                      filter: {
                          isDeleted: { eq: 0 }
                      }
                  ) {
                      items {
                          id
                          name
                          status
                          code
                          createdAt
                          isDeleted
                      }
                  }
              }
              nextToken
          }
      }`;

      const results = await API.graphql(
        graphqlOperation(listEventCompanys, {
          filter: {
            isDeleted: {
              eq: 0
            }
          },
          limit: 10,
          nextToken: this.nextToken
        })
      );
      this.nextToken = results.data.listEventCompanys.nextToken;
      return results.data.listEventCompanys.items;
    },
    async getBookingsByCodeRecord(code) {
      const event = await Booking.getEventWithAllBookings(code);
      let booking = [];
      if (event[0]) {
        event[0].eventLocation.items.forEach(function(event) {
          event.eventSlotGroup.items.forEach(function(eventSlotGroup) {
            eventSlotGroup.eventSlot.items.forEach(function(eventSlot) {
              if (eventSlot.eventBooking.items[0]) {
                booking.push({
                  id: eventSlot.eventBooking.items[0].id,
                  email: eventSlot.eventBooking.items[0].email,
                  firstName: eventSlot.eventBooking.items[0].firstname,
                  lastName: eventSlot.eventBooking.items[0].lastname
                });
              }
            });
          });
        });
      }
      return booking;
    },
    async selectEvents() {
      let booking = [];
      this.bookings = [];
      this.selectedEvents.forEach(async event => {
        booking = await this.getBookingsByCodeRecord(event.code);
        this.bookings.push(...booking);
        this.viewEvent = false;
        this.viewBooking = true;
      });
    },
    copyEmailsIntoClipboard() {
      let emails = this.selectedBookings.map(function(booking) {
        return `${booking.firstName} ${booking.lastName} <${booking.email}>`;
      });

      this.cliboardCopy(emails.join());
      this.clipboardMsg = true;
    },
    cliboardCopy(text) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
    }
  },
  async created() {
    const that = this;

    this.loader = true;
    const companies = await this.nextCompanyRecord();
    while (this.nextToken !== null) {
      let item = await this.nextCompanyRecord();
      companies.push(...item);
    }
    companies.forEach(function(company) {
      company.event.items.forEach(function(event) {
        if (event.status !== null) {
          that.companies.push({
            id: event.id,
            name: company.name,
            email: company.email,
            logo: company.logo,
            eventName: event.name,
            status: event.status,
            code: event.code,
            createdAt: company.createdAt
          });
        }
      });
    });
    this.loader = false;
  }
};
</script>
